import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { TASK_CATEGORY_API } from "../apiRoutes";

interface mutateProps { id: string, data: FieldValues }

const mutateUpdateTaskCategory = async ({ id, data }: mutateProps) => {
  return await axiosAuth.put(`${TASK_CATEGORY_API}/${id}`, data);
};

const useUpdateTaskCategoryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateTaskCategory,
    ...queryParams,
  });

export default useUpdateTaskCategoryMutation;
